import { render, staticRenderFns } from "./ProCard2.vue?vue&type=template&id=e3ee12c0&scoped=true"
import script from "./ProCard2.vue?vue&type=script&lang=js"
export * from "./ProCard2.vue?vue&type=script&lang=js"
import style0 from "./ProCard2.vue?vue&type=style&index=0&id=e3ee12c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ee12c0",
  null
  
)

export default component.exports